import React from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { HOADONTHANHTOAN_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { messageToast, status200 } from '../../../../utils/define';
import HoaDonThanhToanForm, { emptyInvoice } from './HoaDonThanhToanForm';

const HoaDonThanhToanAdd = () => {
    const history = useHistory();
    const mutation = useMutation((value) => Post(HOADONTHANHTOAN_API.ADD_ITEM, null, value, false));
    const onSubmit = (values) => mutation.mutate(values, {
        onSuccess: (res) => {
            if (res.status !== status200 && res.status !== 201)
                return toast.error(messageToast.messageToastCreateError);
            toast.success(messageToast.messageToastCreateSuccess);
            history.push(URI_INTERNAL.HOADONTHANHTOAN_PATH);
        },
        onError: (err) => toast.error(err?.message || messageToast.messageToastTryCatch)
    });
    return <HoaDonThanhToanForm title="Thêm mới hóa đơn thanh toán"
        initialValues={emptyInvoice} submitText="Thêm" isSubmitting={mutation.isLoading}
        onSubmit={onSubmit} onCancel={() => history.push(URI_INTERNAL.HOADONTHANHTOAN_PATH)} />;
};

export default HoaDonThanhToanAdd;
